import { render, staticRenderFns } from "./MuzekkereAdresBilgileriForm.vue?vue&type=template&id=2ba7731c"
import script from "./MuzekkereAdresBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./MuzekkereAdresBilgileriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports